// extracted by mini-css-extract-plugin
export default {"notAvailable":"NetPrice__notAvailable___A1Dsx"};